import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const pickupNotesMachine = createTripArrayFieldMachine('pickupNotes');
